exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-1186f5b2] .template-row {\n  border: 2px dotted black;\n  margin: 8px;\n  padding: 16px;\n}\n[data-v-1186f5b2] .template-row.selected-row {\n    border: 2px dashed gray;\n}\n.item-picker-column h5[data-v-1186f5b2] {\n  position: relative;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);

